import { AxiosPromise, AxiosResponse } from 'axios';
import { Segment, SegmentPayload } from '@dev/ee-api/ee-api-models';
import { request } from './request';

export const loadSegments = (params?: {
    includeHistory?: boolean;
    limit?: number;
    offset?: number;
    from?: string;
    to?: string;
    searchName?: string;
}): AxiosPromise<Segment[]> => {
    const { includeHistory, limit, offset, from, to, searchName } = params;
    const { Segments } = request();
    return Segments.segmentsGet(searchName, includeHistory, from, to, offset, limit).then(
        (resp): AxiosResponse<Segment[]> => {
            resp.data.forEach((singleSegment) => {
                if (singleSegment.Rule.includes("'True'")) {
                    singleSegment.Rule = singleSegment.Rule.replace("'True'", 'True');
                } else if (singleSegment?.Rule.includes("'False'")) {
                    singleSegment.Rule = singleSegment.Rule.replace("'False'", 'False');
                }
            });
            return resp;
        }
    );
};

export const deleteSegment = (name: string): Promise<void> => {
    const { Segments } = request();
    return Segments.segmentsByNameDelete(name).then((resp): void => resp.data);
};

export const addSegment = (body: { Name: string; Rule: string }): Promise<Segment> => {
    const { Segments } = request();
    return Segments.segmentsPost(body).then((resp): Segment => resp.data);
};

export const loadSingleSegment = (name: string): Promise<Segment> => {
    const { Segments } = request();
    return Segments.segmentsByNameGet(name).then((resp): Segment => {
        if (resp.data.Rule.includes("'True'")) {
            resp.data.Rule = resp.data.Rule.replace("'True'", 'True');
        } else if (resp.data?.Rule.includes("'False'")) {
            resp.data.Rule = resp.data.Rule.replace("'False'", 'False');
        }

        return resp.data;
    });
};

export const loadSegmentHistory = (params: {
    includeHistory?: boolean;
    from?: string;
    to?: string;
    options?: any;
}): Promise<Segment[]> => {
    const { includeHistory = true, from, to, options } = params;
    const { Segments } = request();
    return Segments.segmentsTrackedhistoryGet(includeHistory, from, to, options).then(
        (response): Segment[] => response.data
    );
};

export const loadContactSegments = (email: string): Promise<Segment[]> => {
    const { Segments } = request();
    return Segments.segmentsContactsByEmailGet(email).then((resp): Segment[] => resp.data);
};

export const updateSegment = (params: { name: string; segmentPayload: SegmentPayload }): AxiosPromise<Segment> => {
    const { name, segmentPayload } = params;
    const { Segments } = request();
    return Segments.segmentsByNamePut(name, segmentPayload);
};
